import { Injectable } from '@angular/core';
import { RestCallService } from '../../../../core/services/rest-call/rest-call.service';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { NotificationService } from 'src/app/core/services/notification/notification.service';
import { TranslateApplicationService } from '../../../../core/translate/translate-application-service';
import { CognitoService } from 'src/app/core/services/cognito/cognito.service';
import { IEmployees } from '../Interfaces/IEmployees';
import { ActiveDirectoryService } from './activedirectory-services';
import { IEmployeesApproversAreas } from '../Interfaces/IEmployeesApproersAreas';
import { IBuildings } from '../Interfaces/IBuildings';
import { IApproversAreas } from '../Interfaces/IApproversAreas';
import { string0To255 } from 'aws-sdk/clients/customerprofiles';
@Injectable({
    providedIn: 'root',
})
export class EmployeesService extends RestCallService {
    public dataToSend: IEmployees = {
        pkemployee: 0,
        employeename: '',
        username: '',
        workdayid: '',
        employeenumber: '',
        fkrole: 0,
        fkbuilding: 0,
        fksite: 0,
        fksites: [],
        fkapproverarea: 0,
        fkemployeecreator: 0,
        employeecreatorname: '',
        creationdate: new Date(),
        strcreationdate: '',
        lastupdated: new Date(),
        strlastupdated: '',
        fkemployeeupdater: 0,
        employeeupdatername: '',
        email: '',
        available: false,
        usernameupdater: '',
        position: '',
        check: false,
        markCheckboxes: false,
    pksite: 0,
    pkbuildings: [],
    role: '',
    canedit: true,
    };
    dataToSendApproversArea: IEmployeesApproversAreas = {
        pkemployeesapproverarea: 0,
        fkemployee: 0,
        username: '',
    fkapproverarea: 0,
    pkapproverarea: 0,
    approverarea: '',
        fkbuilding: 0,
        creationdate: new Date(),
        strcreationdate: '',
        fkemployeecreator: 0,
        lastupdated: new Date(),
        strlastupdated: '',
        fkemployeeupdater: 0,
        usernameupdater: '',
        available: false,
        fksite: 0,
    };
    constructor(
        public httpClient: HttpClient,
        private cognitoService: CognitoService,
        public toastr: ToastrService,
        public notificationService: NotificationService,
        public activeDirectoryService: ActiveDirectoryService,
        public translate: TranslateApplicationService,
    ) {
        super(httpClient, 'JACSapi', toastr, notificationService, translate);
    }
    public GetList() {
        if (!this.cognitoService.IsAuhtenticated()) {
            this.cognitoService.LogOut();
        }
        this.dataToSend.fksite = Number(window.localStorage.getItem('pksite'));
        return this.post<IEmployees[]>(
            '/api/Employees/GetEmployees',
            this.dataToSend,
        );
    }
    public GetUsersBySite() {
        if (!this.cognitoService.IsAuhtenticated()) {
            this.cognitoService.LogOut();
        }
        this.dataToSend.fksite = Number(window.localStorage.getItem('pksite'));
        return this.post<IEmployees[]>(
            '/api/Employees/GetEmployeesBySite',
            this.dataToSend,
        );
    }
    public GetEmployeeByUserName(userName: string) {
        if (!this.cognitoService.IsAuhtenticated())
            this.cognitoService.LogOut();
        this.dataToSend.username = userName;
        this.dataToSend.fksite = Number(window.localStorage.getItem('pksite'));
        return this.post<IEmployees[]>(
            '/api/Employees/GetEmployeeByUserName',
            this.dataToSend,
        );
    }
    public GetEmployeeByUserNameAndSite(workdayid: string) {
        if (!this.cognitoService.IsAuhtenticated())
            this.cognitoService.LogOut();
        this.dataToSend.workdayid = workdayid;
        this.dataToSend.fksite = Number(window.localStorage.getItem('pksite'));
        return this.post<IEmployees[]>(
            '/api/Employees/GetEmployeeByUserNameAndSite',
            this.dataToSend,
        );
    }

    public CreateEmployee(data: any) {
        if (!this.cognitoService.IsAuhtenticated()) {
            this.cognitoService.LogOut();
        }
        
        this.dataToSend.workdayid = data.txtworkdayid;
        this.dataToSend.username = data.txtusername;
        this.dataToSend.employeename = data.txtemployeename;
        this.dataToSend.email = data.txtemail;
        this.dataToSend.position = data.txtposition;
        this.dataToSend.fkrole = data.cbfkrole == null ? 0 : data.cbfkrole;
        this.dataToSend.employeenumber = data.txtemployeenumber;
        this.dataToSend.fksite = Number(window.localStorage.getItem('pksite'));
        return this.post<boolean>(
            '/api/Employees/CreateEmployee',
            this.dataToSend,
        );
    }
    public ChangeEmployeeStatusBySite(data: any) {
        if (!this.cognitoService.IsAuhtenticated())
            this.cognitoService.LogOut();
        this.dataToSend.username = data.username;
        this.dataToSend.fksite = Number(window.localStorage.getItem('pksite'));
        return this.post(
            '/api/Employees/ChangeEmployeeStatusBySite',
            this.dataToSend,
        );
    }
    public SetEmployeeRoleSite(data: any) {
        if (!this.cognitoService.IsAuhtenticated())
      this.cognitoService.LogOut();
        this.dataToSend.fkrole = data.cbfkrole;
        this.dataToSend.username = data.txtusername;
        this.dataToSend.fksite = Number(window.localStorage.getItem('pksite'));
        return this.post('/api/Employees/SetEmployeeRoleSite', this.dataToSend);
    }
    public SetEmployeeDefaultAdminRole(data: any) {
        if (!this.cognitoService.IsAuhtenticated())
            this.cognitoService.LogOut();
        this.dataToSend.pkemployee = data.pkemployee;
        this.dataToSend.username = data.txtusername;
        this.dataToSend.pksite = data.pksite;
        this.dataToSend.fksite = Number(window.localStorage.getItem('pksite'));
        return this.post(
            '/api/Employees/SetEmployeeDefaultAdminRole',
            this.dataToSend,
        );
    }
    public SetEmployeeBuilding(fkEmployee: number, username: string, building: any) {
        if (!this.cognitoService.IsAuhtenticated())
            this.cognitoService.LogOut();
        this.dataToSend.pkemployee = fkEmployee;
        this.dataToSend.username = username;
        this.dataToSend.fkbuilding = building.pkbuilding;
        this.dataToSend.available = building.available;
        this.dataToSend.fksite = Number(window.localStorage.getItem('pksite'));
        return this.post('/api/Employees/SetEmployeeBuilding', this.dataToSend);
    }
    public CreateEmployeeRolesSites(data: any, fksite: number) {
        if (!this.cognitoService.IsAuhtenticated())
            this.cognitoService.LogOut();
        this.dataToSend.pkemployee = data.pkemployee;
        this.dataToSend.username = data.txtusername;
        this.dataToSend.fksite = fksite;
        return this.post(
            '/api/Employees/CreateEmployeesRolesSites',
            this.dataToSend,
        );
    }
    public SetEmployeeApproverArea(data: any, building: any, approverarea: any) {
        if (!this.cognitoService.IsAuhtenticated())
            this.cognitoService.LogOut();
        this.dataToSend.username = data.txtusername;
        this.dataToSend.fkbuilding = building.pkbuilding;
        this.dataToSend.fkapproverarea = approverarea.pkapproverarea;
        this.dataToSend.available = approverarea.available;
        this.dataToSend.fksite = Number(window.localStorage.getItem('pksite'));
    return this.post(
            '/api/Employees/SetEmployeeApproverArea',
            this.dataToSend,
        );
    }
    public UpdateEmployeeRolesAndSites(data: any) { ///
        if (!this.cognitoService.IsAuhtenticated())
      this.cognitoService.LogOut();
        this.dataToSend.pkemployee = data.pkemployee;
        this.dataToSend.username = data.txtusername;
        this.dataToSend.fksite = Number(window.localStorage.getItem('pksite'));
        return this.put(
            '/api/Employees/UpdateEmployeeRolesAndSites',
            this.dataToSend,
        );
    }
    public GetEmployeesApproversAreas(pkemployee: number) {
        if (!this.cognitoService.IsAuhtenticated())
            this.cognitoService.LogOut();
    this.dataToSendApproversArea.fkemployee = pkemployee;
        this.dataToSendApproversArea.fksite = Number(window.localStorage.getItem('pksite'));
        return this.post<IApproversAreas[]>(
            '/api/Employees/GetEmployeesApproversAreas',
            this.dataToSendApproversArea,
        );
    }
    public GetBuildingsByUser(data: any) {
        if (!this.cognitoService.IsAuhtenticated())
            this.cognitoService.LogOut();
        this.dataToSend.fksite = parseInt(localStorage.getItem('pksite'));
        this.dataToSend.username = data.txtusername;
        return this.post<IBuildings[]>(
            '/api/Employees/GetEmployeesBuildings',
            this.dataToSend,
        );
    }
    public UpdateEmployee(data: any) {
        if (!this.cognitoService.IsAuhtenticated()) {
            this.cognitoService.LogOut();
        }
        this.dataToSend.pkemployee = data.pkemployee;
        this.dataToSend.workdayid = data.txtworkdayid;
        this.dataToSend.username = data.txtusername;
        this.dataToSend.employeename = data.txtemployeename;
        this.dataToSend.email = data.txtemail;
        this.dataToSend.position = data.txtposition;
        this.dataToSend.fkrole = data.fkrole;
        this.dataToSend.employeenumber = data.txtemployeenumber;
        this.dataToSend.fksite = Number(window.localStorage.getItem('pksite'));
        return this.put<boolean>(
            '/api/Employees/UpdateEmployee',
            this.dataToSend,
        );
    }
}